import { useState, useEffect } from "react";
import ProtectedPage from "../../../common/ProtectedPage";
import ClientHeader from "../../../common/ClientHeader";
import ClientsAdressesQueries from "../../../../requests/queries/ClientsAdressesQueries";
import { CategoriesQueriesClient } from "../../../../requests/queries/CategoriesQueries";
import "./CheckoutPageStyles.css";
import { Link } from "react-router-dom";
import CommandsQueries from "../../../../requests/queries/CommandsQueries";
import LoadingSpinner from "../../../common/Loading";
import {convertColorToHex} from "../../../../utils/utils";
import Sidebar from "../../../common/Sidebar";

export default function CheckoutPage({ currentCommand, setCurrentCommand }) {

    const [isLoading, setIsLoading] = useState(true);
    const [adresses, setAdresses] = useState([]);
    const [selectedAddress, setSelectedAddress] = useState(null);
    const [totalPrice, setTotalPrice] = useState(0);
    const [error, setError] = useState(null);
    const [categories, setCategories] = useState([]);

    useEffect(() => {
        setIsLoading(true);
        ClientsAdressesQueries.findAllForClient().then((res) => {
            setAdresses(res.data.addresses);
            setIsLoading(false);
        }).catch(() => {
            setIsLoading(false);
        });
    }, []);

    useEffect(() => {
        const fetchCategories = async () => {
            try {
                const res = await CategoriesQueriesClient.findAll();
                setCategories(res.data.categories);
            } catch (err) {
                console.error("Erreur lors du chargement des catégories:", err);
            }
        };
        fetchCategories();
    }, []);

    const updateSelectedAddress = async () => {
        if(!currentCommand || !selectedAddress) {
            return;
        }
        await CommandsQueries.updateClientAddress(currentCommand.id, {client_address_id: selectedAddress});
        setCurrentCommand({...currentCommand, client_address_id: selectedAddress});
    }

    useEffect(() => {
        if(!currentCommand || !selectedAddress){
            return;
        }
        updateSelectedAddress();
    }, [selectedAddress]);

    useEffect(() => {
        setSelectedAddress(currentCommand?.client_address_id || null);
    }, [currentCommand]);

    useEffect(() => {
        if(!isLoading && (!currentCommand || !currentCommand.products || !currentCommand.products.length)){
            window.location.href = '/shop';
        }
    }, [currentCommand, isLoading]);

    const handlePayment = async () => {
        setIsLoading(true);
        try {
        const res = await CommandsQueries.getPaymentUrl(currentCommand.id);
            if(res.data){
                window.location.href = res.data.paymentUrl;
            } else {
                setError(res.data.message);
                setIsLoading(false);
            }
        } catch (error) {
            setError(error.response?.data?.message || 'Error retrieving payment URL');
            setIsLoading(false);
        }
    }
    
    return (
        <ProtectedPage 
            key={`checkout-${currentCommand?.id}`}
            permissionsNeeded="client" 
            needToBeAuthenticated={true} 
            redirectPath="/client-secret"
            currentCommand={currentCommand}
            setCurrentCommand={setCurrentCommand}
        >
            {isLoading ? (
                <LoadingSpinner />
            ) : (
                <>
                    <div className="patricians-layout">
                        <ClientHeader displayCart={false} currentCommand={currentCommand} setCurrentCommand={setCurrentCommand} />
                        <div className="patricians-main-content">
                            {/* Sidebar gauche avec catégories */}
                            <Sidebar />

                            {/* Zone principale avec le contenu checkout */}
                            <div className="checkout-container">
                                <div className="checkout-content">
                                <h1>Checkout</h1>
                                <h2>
                                    Choisissez une adresse de livraison :
                                </h2>
                                <div className="checkout-form">
                                    <div className="checkout-form-group">
                                        {
                                            adresses.length > 0 ? (
                                                adresses.map((address) => (
                                                    <div className={`checkout-form-group-item ${selectedAddress === address.id ? 'selected' : ''}`} key={address.id}>
                                                        <h2>{address.first_name} {address.last_name}</h2>
                                                        <p>{address.street} {address.number}</p>
                                                        <p>{address.zip_code} {address.city} {address.country}</p>
                                                        {
                                                            address.complement && (
                                                                <p>{address.complement}</p>
                                                            )
                                                        }
                                                        <p>Added on {new Date(address.created_at).toLocaleDateString('en-GB', { 
                                                            year: 'numeric', 
                                                            month: 'long', 
                                                            day: 'numeric' 
                                                        })}</p>
                                                        <button className="btn-primary" onClick={() => setSelectedAddress(address.id)}>Use this address</button>
                                                    </div>
                                                ))
                                            ) : (
                                                <div className="checkout-form-group-item">
                                                    <h3>No address found</h3>
                                                    <p>You have not added a delivery address yet. Add an address to choose one when placing your order.</p>
                                                </div>
                                            )
                                        }
                                        <Link to="/client/profile" className="checkout-add-address-link">
                                            <button className="btn-primary checkout-add-address-btn">Add an address</button>
                                        </Link>
                                    </div>
                                </div>
                                {
                                    selectedAddress && currentCommand?.id && (
                                        <ProductList totalPrice={totalPrice} setTotalPrice={setTotalPrice} commandId={currentCommand.id} />
                                    )
                                }

                                {
                                    selectedAddress && currentCommand?.id && (
                                        <div className="checkout-summary">
                                            <div className="checkout-summary-card">
                                                <h2 className="checkout-summary-title">
                                                    Order summary
                                                </h2>
                                                <div className="checkout-summary-content">
                                                    <div className="checkout-summary-row">
                                                        <span className="checkout-summary-label">Total price:</span>
                                                        <span className="checkout-summary-price">{totalPrice.toFixed(2)} €</span>
                                                    </div>
                                                </div>
                                                <button onClick={handlePayment} className="checkout-payment-btn">
                                                    <span className="checkout-payment-btn-content">
                                                        <i className="bi bi-credit-card"></i>
                                                        <span>Pay for order</span>
                                                    </span>
                                                    <span className="checkout-payment-btn-arrow">
                                                        <i className="bi bi-arrow-right"></i>
                                                    </span>
                                                </button>
                                                {error && (
                                                    <div className="alert alert-danger mt-5">
                                                        {error}
                                                    </div>
                                                )}
                                            </div>
                                        </div>
                                    )
                                }
                                </div>
                            </div>
                        </div>
                    </div>
                </>
            )}
        </ProtectedPage>
    )
}

const ProductList = ({commandId, totalPrice, setTotalPrice}) => {
    const [products, setProducts] = useState([]);
    const [isLoading, setIsLoading] = useState(true);
    const [error, setError] = useState(null);

    const calculateTotalPrice = () => {
        if(!products){
            return;
        }
        return products.reduce((total, product) => total + product.variants.reduce((total, variant) => total + variant.quantity * product.prices.find(price => price.id === product.default_price_id)?.price, 0), 0);
    }

    useEffect(() => {
        CommandsQueries.findById(commandId).then((res) => {
            setProducts(res.data.command.products);
            setIsLoading(false);
        }).catch(() => {
            setIsLoading(false);
            setError("Error loading products");
        });
    }, [commandId]);

    useEffect(() => {
        setTotalPrice(calculateTotalPrice());
    }, [products]);

    if(isLoading) {
        return (
            <LoadingSpinner />
        )
    }

    if(error) {
        return (
            <div className="alert alert-danger">
                {error}
            </div>
        )
    }

    return (
        <div className="checkout-products-section">
            <h2 className="checkout-products-title">
                Liste des produits
            </h2>
            <div className="checkout-products-grid">
                {
                    products.map((product) => {
                        const unitPrice = parseFloat(product.prices.find(price => price.id === product.default_price_id)?.price || 0);
                        const productTotal = product.variants.reduce((total, variant) => total + variant.quantity * unitPrice, 0);
                        
                        return (
                            <div className="checkout-product-card" key={product.id}>
                                <div className="checkout-product-image">
                                    <img 
                                        src={product.images[0]?.image_url || 'https://via.placeholder.com/300x300?text=Image'} 
                                        alt={product.name} 
                                    />
                                </div>
                                <div className="checkout-product-content">
                                    <h3 className="checkout-product-name">{product.name}</h3>
                                    <div className="checkout-product-unit-price">
                                        Unit price: <span className="checkout-price-value">{unitPrice.toFixed(2)} €</span>
                                    </div>
                                    <div className="checkout-product-variants">
                                        <div className="checkout-variants-title">Variants:</div>
                                        {
                                            product.variants.map((variant) => (
                                                <div className="checkout-variant-item" key={variant.id}>
                                                    <div className="checkout-variant-header">
                                                        <span 
                                                            className="checkout-variant-color" 
                                                            style={{
                                                                backgroundColor: convertColorToHex(variant.color), 
                                                                border: '2px solid rgba(0, 0, 0, 0.1)'
                                                            }}
                                                        ></span>
                                                        <span className="checkout-variant-subtotal">
                                                            {(unitPrice * variant.quantity).toFixed(2)} €
                                                        </span>
                                                    </div>
                                                    <div className="checkout-variant-info">
                                                        <div className="checkout-variant-attribute">
                                                            <span className="checkout-variant-label">Color:</span>
                                                            <span className="checkout-variant-detail">{variant.color}</span>
                                                        </div>
                                                        <div className="checkout-variant-attribute">
                                                            <span className="checkout-variant-label">Size:</span>
                                                            <span className="checkout-variant-detail">{variant.size}</span>
                                                        </div>
                                                        <div className="checkout-variant-attribute">
                                                            <span className="checkout-variant-label">Quantity:</span>
                                                            <span className="checkout-variant-detail">{variant.quantity}</span>
                                                        </div>
                                                    </div>
                                                </div>
                                            ))
                                        }
                                    </div>
                                    <div className="checkout-product-total">
                                        <span className="checkout-product-total-label">Product total:</span>
                                        <span className="checkout-product-total-value">{productTotal.toFixed(2)} €</span>
                                    </div>
                                </div>
                            </div>
                        )
                    })
                }
            </div>
        </div>
    )
}